module.exports = __webpack_public_path__ + "static/media/blog.2f74aca8.png";